import React, { useState } from "react";
import { XCircle } from "lucide-react";
import Button, { ButtonType } from "../Assets/Button";

interface RejectRepaymentModalProps {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (remark: string) => void;
}

const RejectRepaymentModal: React.FC<RejectRepaymentModalProps> = ({
  open,
  loading,
  onClose,
  onSubmit,
}) => {
  const [remark, setRemark] = useState("");

  if (!open) return null;

  const handleSubmit = () => {
    if (!remark.trim()) return;
    onSubmit(remark);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">Reject Repayment</h2>
          <button onClick={onClose}>
            <XCircle className="w-5 h-5 text-slate-500" />
          </button>
        </div>

        <textarea
          placeholder="Enter rejection remark..."
          className="w-full border border-slate-200 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-gray-500"
          rows={4}
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
        />

        <div className="flex justify-end gap-2 mt-4">
          <Button
            type={ButtonType.Cancel}
            onClick={onClose}
            className="text-xs"
          >
            Cancel
          </Button>

          <Button
            type={ButtonType.Error}
            onClick={handleSubmit}
            disabled={loading}
            className="text-xs"
          >
            {loading ? "Rejecting..." : "Reject"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RejectRepaymentModal;
